import { render, staticRenderFns } from "./contractDetailRoom.vue?vue&type=template&id=856fcab0&scoped=true"
import script from "./contractDetailRoom.vue?vue&type=script&lang=js"
export * from "./contractDetailRoom.vue?vue&type=script&lang=js"
import style0 from "./contractDetailRoom.vue?vue&type=style&index=0&id=856fcab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856fcab0",
  null
  
)

export default component.exports